"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Duration = _interopRequireDefault(require("web/shared/telemetry/components/Duration"));
var _ScatterPoints = _interopRequireDefault(require("web/shared/telemetry/charts/ScatterPoints"));
var _DurationsOverTimeData = require("web/shared/telemetry/charts/DurationsOverTime.data.js");
var _clock = require("web/shared/telemetry/format/clock.js");
var _DurationsOverTimeStyles = require("web/shared/telemetry/charts/DurationsOverTime.styles.js");
var _popoverStyles = require("web/shared/telemetry/charts/popover.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The durations plot: the points, the axes they sit against, and the popover
* that names whichever one the cursor is nearest.
*
* Separate from the panel that frames it, so this file is about drawing the
* series and the interaction over it, and nothing else.
*/ // How many guides each axis carries. Enough to read a position against, few
// enough that the labels do not collide on a narrow panel.
const GUIDE_COUNT = 4;
function DurationsPlot(_ref) {
  let records = _ref.records;
  const _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  const _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    lastHovered = _useState4[0],
    setLastHovered = _useState4[1];
  const plotRef = React.useRef(null);
  const points = React.useMemo(() => (0, _DurationsOverTimeData.buildTimeline)(records), [records]);
  const _plotBounds = (0, _DurationsOverTimeData.plotBounds)(points),
    firstMs = _plotBounds.firstMs,
    spanMs = _plotBounds.spanMs,
    slowest = _plotBounds.slowest; // One handler on the plot rather than one per point. Hundreds of listeners
  // would make the plot slow, and finding the nearest point from the cursor is
  // both cheaper and more forgiving to aim at.
  const onMove = React.useCallback(event => {
    const plot = plotRef.current;
    if (plot == null || points.length === 0) {
      return;
    }
    const box = plot.getBoundingClientRect();
    const x = (event.clientX - box.left) / box.width;
    const y = 1 - (event.clientY - box.top) / box.height;
    let nearest = 0;
    let best = Number.POSITIVE_INFINITY;
    points.forEach((point, index) => {
      const pointX = spanMs > 0 ? (point.startedAtMs - firstMs) / spanMs : 0.5;
      const pointY = slowest > 0 ? point.durationMs / slowest : 0; // Time weighted above duration: the axis a reader is scanning along.
      const distance = (pointX - x) ** 2 * 4 + (pointY - y) ** 2;
      if (distance < best) {
        best = distance;
        nearest = index;
      }
    });
    setHovered(nearest);
    setLastHovered(nearest);
  }, [points, firstMs, spanMs, slowest]);
  if (points.length < 2) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
      children: "Not enough completed measurements in this window to plot a trend."
    }));
  }
  const active = hovered != null ? points[hovered] : null; // Retained after the cursor leaves, so the popover fades out from where it
  // was rather than disappearing mid-thought.
  const settled = hovered != null ? hovered : lastHovered;
  const shown = settled != null ? points[settled] : null;
  const fractions = Array.from({
    length: GUIDE_COUNT + 1
  }, (unused, index) => index / GUIDE_COUNT);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.scatter)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        ref: plotRef
      }, stylex.props(_DurationsOverTimeStyles.styles.scatterPlot)), {}, {
        onMouseMove: onMove,
        onMouseLeave: () => setHovered(null),
        children: [fractions.map(fraction => /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.gridLineHorizontal)), {}, {
            style: {
              bottom: "".concat(fraction * 100, "%")
            }
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.gridLabelHorizontal)), {}, {
            style: {
              bottom: "".concat(fraction * 100, "%")
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
              ms: slowest * fraction
            })
          }))]
        }, "duration-".concat(fraction))), fractions.map(fraction => /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.gridLineVertical)), {}, {
            style: {
              left: "".concat(fraction * 100, "%")
            }
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.gridLabelVertical)), {}, {
            style: {
              left: "".concat(fraction * 100, "%")
            },
            children: (0, _clock.formatLocalClock)(firstMs + spanMs * fraction)
          }))]
        }, "time-".concat(fraction))), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScatterPoints.default, {
          points: points,
          firstMs: firstMs,
          spanMs: spanMs,
          slowest: slowest
        }), active != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.scatterPoint, _DurationsOverTimeStyles.styles.scatterPointActive)), {}, {
          style: {
            left: spanMs > 0 ? "".concat((active.startedAtMs - firstMs) / spanMs * 100, "%") : "50%",
            bottom: slowest > 0 ? "".concat(active.durationMs / slowest * 100, "%") : "0%"
          }
        })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popover, active != null ? _popoverStyles.styles.popoverShown : _popoverStyles.styles.popoverHidden)), {}, {
          style: {
            left: shown != null && spanMs > 0 ? "".concat((shown.startedAtMs - firstMs) / spanMs * 100, "%") : "50%",
            bottom: shown != null && slowest > 0 ? "".concat(shown.durationMs / slowest * 100, "%") : "0%"
          },
          children: shown != null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverRow)), {}, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
                ms: shown.durationMs
              })
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverRow)), {}, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverFigure)), {}, {
                children: (0, _clock.formatLocalDate)(shown.startedAtMs)
              }))
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverRow)), {}, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_popoverStyles.styles.popoverFigure)), {}, {
                children: (0, _clock.formatLocalTimeOfDay)(shown.startedAtMs)
              }))
            }))]
          }) : null
        }))]
      }))
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.footnote)), {}, {
      children: [points.length, " completed measurements"]
    }))]
  });
}
var _default = exports.default = DurationsPlot;